// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import config from './utils/config'
import axiosService from './utils/axios'
import defaultImage from './utils/defaultImage'
import messageType from './jsSdk/model/MessageType'
import VueLazyLoad from 'vue-lazyload'
import messageBox from './components/common/message/messageBox.js'
import * as permissionRoute from './permission'
import * as globalSet from './utils/globalSet'
import VueJsonp from 'vue-jsonp'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
//Vue.use(Viewer) 默认配置写法
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
});
Vue.use(VueJsonp)
Vue.config.productionTip = false;
Vue.use(VueLazyLoad);

Vue.prototype.$config = config;
Vue.prototype.$axiosService = axiosService;
Vue.prototype.$defaultImage = defaultImage;
Vue.prototype.$messageType = messageType;
Vue.prototype.$messageBox = messageBox;
Vue.prototype.$globalSet = globalSet;
Vue.prototype.$permissionRoute = permissionRoute;
Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp'];


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
